import { useTranslation } from 'react-i18next';
import styles from './footer.module.scss';
import { useNavigate } from 'react-router-dom';

export function Footer() {

    const { t } = useTranslation();
    const navigate = useNavigate();

    return (
        <footer className={styles.bFooter}>
            <div className={styles.bFooterGrid}>

                <div style={{ textAlign: "center" }}><a className={styles.ba} onClick={() => { navigate("/kontakt") }}>Kontakt</a></div>
                <div style={{ textAlign: "center" }}><a className={styles.ba} onClick={() => { navigate("/impressum") }}>Impressum</a></div>
                <div style={{ textAlign: "center" }}>
                    Kundenzugang: <a className={styles.ba} href="https://app.bergamotti.de">app.bergamotti.de</a>
                </div>

            </div>
        </footer>
    );
}

export default Footer;
